<template>

  <b-modal :id="modalId" modal-class="modal-checkout-paywithbanktransfer" centered @shown="shown" @hidden="hide"
           no-close-on-esc no-close-on-backdrop hide-header-close hide-header hide-footer>
    <!--    <template v-slot:modal-header class="text-center">
          <h5 class="modal-title">{{ $t('pages.checkout.modal_payment_withmercadopago_modal_title') }}</h5>
          <button type="button" aria-label="Close" class="close" @click="$bvModal.hide(modalId)"></button>
        </template>

        <Loader v-show="isLoadingPaymentMethods"/>-->

    <Loader v-show="isLoadingOrder">
      <template #message>{{ $t('pages.checkout.modal_payment_processing_text') }}</template>
    </Loader>


    <!--
        <section v-if="hasMercadoPagoError" style="border: 1px solid red">
          <h2>{{ $t('pages.checkout.modal_payment_processing_error_title') }}</h2>
          <p>{{ mercadoPagoError.message }}</p>
        </section>



        <div class="row mt-3" v-show="!isLoading && !hasMercadoPagoError">
          <div class="col-md-8" v-if="countries">
            <div class="form-group">
              <label for="">{{ $t('shipping_address_fields.country_of_residence') }}</label>
              <multiselect
                  id="addressCountry" name="addressCountry"
                  :data-vv-as="$t('shipping_address_fields.country')" v-validate="'required'"
                  :placeholder="$t('shipping_address_fields.country_placeholder')"
                  track-by="code"
                  :options="countries"
                  v-model="addressCountry"
                  :custom-label="(opt) => `${opt.code} ${opt.name}`"
                  :show-labels="false">
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong>
                </template>

                <template slot="option" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong>
                </template>
                <span slot="noResult">No country found</span>
              </multiselect>
            </div>
            <span v-show="errors.has('addressCountry')" class="field-error">{{ errors.first('addressCountry') }}</span>

          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="addressPostalCode">{{ $t('shipping_address_fields.zip_code') }}</label>
              <input type="text" id="addressPostalCode" name="addressPostalCode" v-model="addressPostalCode"
                     :data-vv-as="$t('shipping_address_fields.zip_code')" v-validate="{ required: true, max: 10 }"
                     class="form-control">
            </div>
          </div>

          <div class="col-md-12">
            <span v-show="errors.has('addressPostalCode')" class="field-error">{{
                errors.first('addressPostalCode')
              }}</span>
          </div>
        </div>

        <PaymentWithCardInfos :payment-method="PAYMENT_METHOD_MERCADO_PAGO" class="pb-0"/>

        <template v-slot:modal-footer>
          <b-button block variant="primary" class="btn--pay" size="md" @click="pay"
                    v-show="!hasMercadoPagoError" :disabled="isLoadingOrder">
            {{ $tc('pages.checkout.action_stripe_pay') }} {{ totalCartItems.grand_total|formatCurrency(totalCartItems.currency) }}
          </b-button>
          <b-button block size="md" @click="hide" v-if="hasMercadoPagoError">
            {{ $t('pages.checkout.modal_payment_withcard_close') }}
          </b-button>
        </template>-->

  </b-modal>
</template>


<script>
import Multiselect from "vue-multiselect"

import {PAYMENT_METHOD_MERCADO_PAGO} from "@/consts.js"

import Loader from "@/components/Loader"
import PaymentWithCardInfos from "@/components/PaymentWithCardInfos"
import {i18n} from "@/i18n";
import {mapGetters, mapMutations} from "vuex";


export default {
  components: {
    // Multiselect,
    Loader,
    // PaymentWithCardInfos
  },

  props: {
    modalId: {
      type: String,
      required: true
    },
    paymentSettings: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      isLoadingPaymentMethods: false,
      isLoadingOrder: false,
      mercadoPago: null,
      paymentMethods: [],
      countries: [],
      addressCountry: '',
      addressPostalCode: '',
      mercadoPagoError: {},

    }
  },

  created() {
    this.PAYMENT_METHOD_MERCADO_PAGO = PAYMENT_METHOD_MERCADO_PAGO
  },

  computed: {
    ...mapGetters('cartDigitalItems', ['totalCartItems']),
    publicKey() {
      return this.paymentSettings.public_key
    },
    hasPaymentMethods() {
      return this.paymentMethods.length > 0
    },

    hasMercadoPagoError() {
      return Object.keys(this.mercadoPagoError).length > 0
    },

    isLoading() {
      return this.isLoadingPaymentMethods || this.isLoadingOrder
    }
  },

  mounted() {
    /* CartService.getCountries().then(response => {
       this.countries = response.data
     })*/
  },

  methods: {
    ...mapMutations('cartDigitalItems', ['resetCart']),
    resetData() {
      this.isLoadingPaymentMethods = false
      this.isLoadingOrder = false
      // paymentMethods: [],
      this.mercadoPagoError = {}
    },

    async shown() {
      this.isLoadingOrder = true
      await this.setupMercadoPago()
      await this.pay()
    },

    hide() {
      this.resetData()
      this.$bvModal.hide(this.modalId)
    },


    async setupMercadoPago() {
      // eslint-disable-next-line no-undef
      this.mercadoPago = new MercadoPago(this.publicKey, {
        locale: this.getLanguageCode()
      });
    },
    async pay() {
      console.log('Pay MP')

      /*
      await this.$validator.validate() // force validation for country and postal code
      if (this.addressPostalCode === '' || this.addressCountry === '') {
        return false
      }
      this.mercadoPagoError = {}
       */


      let payload = {
        paymentMethod: PAYMENT_METHOD_MERCADO_PAGO,
        /* billingAddress: {
           country: this.addressCountry.code,
           postal_code: this.addressPostalCode
         }*/
      }

      this.$store.dispatch("cart/placeOrder", payload)
          .then(response => {
            const responseData = response.data
            //const orderId = responseData.order_id
            const preferenceId = responseData.preference_id
            const checkoutUrl = responseData.checkout_url

            if (preferenceId) {
              if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging") {
                 document.location.href = checkoutUrl
              } else {
                const checkout = this.mercadoPago.checkout({
                  preference: {
                    id: preferenceId
                  },
                  theme: {
                    elementsColor: '#1d5aff',
                    headerColor: '#100F23',
                  },
                  autoOpen: true
                });

                //reset and close modal
                this.resetCart()
                this.hide()

              }
            }

          })
    },

    // move or refactor
    getLanguageCode() {
      const currentLocale = i18n.locale
      let languageCode = 'en-US'
      if (currentLocale === 'pt') {
        languageCode = 'pt-BR'
      } else if (currentLocale === 'es') {
        languageCode = 'es-AR'
      }
      return languageCode
    }
  }
}
</script>
